export default __webpack_public_path__ + "static/media/197.ff57714e.jpg";